import { RichText, useBlockProps } from '@wordpress/block-editor';
import React from 'react';

interface SaveProps {
  attributes: {
    kicker: string;
    headline: string;
    headlineLevel?: number;
    textAlign?: string;
    className?: string;
  };
}

const Save: React.FC<SaveProps> = ({ attributes: { headline, kicker, headlineLevel, textAlign, className, textColor } }) => {
  return (
    <div {...useBlockProps.save({ class: `wp-block-neodigital-kicker-headline has-text-align-${textAlign || 'left'} ${className ?? ''}` })}>
      <hgroup className="hgroup">
        <p className={`kicker ${textColor ? `has-${textColor}-color` : ''}`}>{kicker}</p>
        <RichText.Content tagName={`h${headlineLevel}`} className="headline" value={headline} />
      </hgroup>
    </div>
  );
};

export default Save;
